import(/* webpackMode: "eager" */ "/vercel/path0/app/(feed)/following/page.tsx");
